import apiSlice from "../api/apiSlice";

const teamApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTeam: build.query({
      query: () => "/team",
    }),
    getSingleTeamMember: build.query({
      query: (name) => `/team?name=${name}`,
    }),
  }),
});

export const { useGetTeamQuery, useGetSingleTeamMemberQuery } = teamApi;
